import { UserData } from '@/shared/types';

import type { GoalSettingsState } from '@/pages/goalSettings/types';

export const getUserData = ({ sharedReducer: { userData } }: any): UserData => userData;

export const getPlayDaysPerWeek = ({
	goalSettingsReducer: { playDaysPerWeek },
}: {
	goalSettingsReducer: GoalSettingsState;
}): number => playDaysPerWeek;
